import Button from "@acko-tech/building-blocks.ui.button-old";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const CouponCardWrapper = styled.div<{ errorMessage?: string }>`
  width: 100%;
  background: linear-gradient(218deg, #f0fdff 0.82%, #f9fdff 99.11%);
  backdrop-filter: blur(10px);
  padding: 20px 14px;
  box-sizing: border-box;
  border-radius: 12px;
  border: 2px solid #CBD3FF;
  ${({ errorMessage }: any) => {
    return errorMessage ? "padding-bottom: 40px;" : null;
  }}}
`;

export const HeadingText = styled(Text)`
  font-size: 12px;
  color: #5b5675;
  text-align: right;
`;

export const CouponParaHeading = styled(Text)`
  color: var(--text-primary-n-600, #040222);
  font-family: 'Euclid Circular B', 'Inter', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  padding: 12px 0px;
`;

export const ApplyDiscountButton = styled(Button)`
  margin-top: 20px;
  color: #040222;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0.1px;
  width: 136px;
  height: 42px;
  background: none;
  border-radius: 8px;
  padding: 16px 8px;
  border: 1px solid var(--Neutral-N600, #040222);

  :hover {
    background-color: inherit;
    border: 1px solid var(--Neutral-N600, #040222);
    color: #040222;
  }
`;

export const CouponPara = styled(Text)`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #36354c;

  @media(min-width: 768px){
    font-size: 14px;
    line-height: 20px;
  }
`;
